import { useFormikContext } from "formik";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import FormikAutocomplete from "../FormikAutocomplete";
import FormikTextField from "../FormikTextField";


const FormikCalle = ({ nameLocationFields, label, calleInicial = "" }) => {

    const { values, setFieldValue } = useFormikContext();

    const calles = useSelector((state) => state.direccion.calle.data);

    const callesMemo = useMemo(() => {
        if (calleInicial && !calles.some((calle) => calle.nombre.toLowerCase() === calleInicial.toLowerCase())) {

            return [...calles, { id: calleInicial, nombre: calleInicial }]
        }
        return calles;
    }, [calles, calleInicial])

    const provinciaIsCapital = values[nameLocationFields.provincia] === "Capital Federal";
    return (
        <>
            {!provinciaIsCapital ? (
                <FormikTextField
                    name={nameLocationFields.calle}
                    label={label ? label : "Calle *"}
                    fullWidth
                    disabled={!values[nameLocationFields.localidad]}
                    onBlur={(value) => {
                        if (!value.target.value) {
                            setFieldValue(nameLocationFields.numero, "");
                            setFieldValue(nameLocationFields.codigoPostal, "");
                        }
                    }}
                />
            ) : (
                <FormikAutocomplete
                    name={nameLocationFields.calle}
                    label={label ? label : "Calle *"}
                    options={callesMemo}
                    fullWidth
                    disabled={!values[nameLocationFields.localidad]}
                    callBack={(value) => {
                        if (!value) {
                            setFieldValue(nameLocationFields.numero, "");
                            setFieldValue(nameLocationFields.codigoPostal, "");
                        }
                    }}
                />
            )
            }
        </>
    );
}

export default FormikCalle;
